export default "__VITE_ASSET__CU9l24nm__"